export class TableData {
    constructor(
        public open: Date,
        public changed: Date,
        public count: number,
        public metric: string,
        public entity: string
    ){}
}



// WEBPACK FOOTER //
// ./src/app/models/table-data.ts